<div class="service-templates-selector">
  <div class="d-flex justify-content-between align-items-center mb-5">
    <h5 class="mb-0">Service Templates</h5>
    <button
      type="button"
      class="btn btn-primary"
      (click)="onCreateWithoutTemplate()"
      [disabled]="isLoadingCurrentTemplate">
      <i class="fas fa-plus me-2"></i>
      {{ createButtonText }}
    </button>
  </div>

  <!-- Filters -->
  <div class="row">
    <div class="col-md-4">
      <div class="form-group">
        <div class="input-group">
          <span class="input-group-text">
            <i class="fas fa-search"></i>
          </span>
          <input
            type="text"
            class="form-control"
            placeholder="Search templates by name"
            [(ngModel)]="searchTerm"
            (ngModelChange)="onSearchChange()" />
        </div>
      </div>
    </div>

    <div class="col-md-3">
      <div class="form-group">
        <div class="input-group">
          <span class="input-group-text">
            <i class="fas fa-tag"></i>
          </span>
          <select
            class="form-select"
            [(ngModel)]="selectedCategory"
            (ngModelChange)="onCategoryChange($event)">
            <option value="">All</option>
            <option
              *ngFor="let category of filteredCategories"
              [value]="category.id">
              {{ category.name }}
            </option>
          </select>
        </div>
      </div>
    </div>
  </div>

  <!-- Templates Table Section -->
  <div class="service-templates-table">
    <irembogov-irembo-section-message
      type="info"
      *ngIf="!isLoading && templates.length < 1"
      class="w-80 mx-auto mt-5 d-block"
      title=""
      message="No published templates are available for use."
      [dismissible]="false">
    </irembogov-irembo-section-message>

    <irembogov-custom-table-wrapper
      [isSortVisible]="false"
      [loading]="isLoading"
      [paginationVisible]="true"
      [totalItems]="totalElements"
      [itemsPerPage]="pageSize"
      [currentPage]="currentPage + 1"
      (paginationChange)="onPageChange($event.pageNumber - 1)">
      <table body aria-label="Service Templates Selection Table" class="table">
        <thead>
          <tr>
            <th scope="col" class="text-nowrap">Template Name</th>
            <th scope="col" class="text-nowrap">Category</th>
            <th scope="col" class="text-nowrap">Action</th>
          </tr>
        </thead>
        <tbody class="rounded bg-white" *ngIf="!isLoading">
          <tr *ngFor="let template of templates; let index = index">
            <td class="text-wrap">
              <div class="d-flex align-items-center">
                <div>
                  <strong>{{ template.name }}</strong>
                  <div class="text-muted small" *ngIf="template.description">
                    <span
                      class="text-muted"
                      [innerHTML]="
                        template.description | slice : 0 : 50
                      "></span>
                    <span
                      *ngIf="
                        template.description && template.description.length > 50
                      "
                      class="text-muted"
                      >...</span
                    >
                  </div>
                </div>
              </div>
            </td>
            <td class="text-wrap">
              <span>
                {{ categoryMap[template.categoryId] || 'Uncategorized' }}
              </span>
            </td>
            <td class="text-nowrap action-column">
              <div class="d-flex gap-2">
                <button
                  type="button"
                  class="btn btn-outline-primary btn-sm"
                  [routerLink]="[
                    '/services/templates',
                    template.id,
                    'preview'
                  ]">
                  <i class="fas fa-eye me-1"></i>
                  View
                </button>
                <button
                  type="button"
                  class="btn btn-primary btn-sm"
                  (click)="useTemplate(template)">
                  <i class="fas fa-check me-1"></i>
                  {{ isCurrentTemplate(template.id) ? 'Use Again' : 'Use' }}
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </irembogov-custom-table-wrapper>
  </div>
</div>

<!-- Template Preview Modal -->
<div
  class="modal fade show"
  [style.display]="showPreviewModal ? 'block' : 'none'"
  [class.show]="showPreviewModal"
  tabindex="-1"
  role="dialog"
  aria-labelledby="templatePreviewModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-xl" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="templatePreviewModalLabel">
          Template Preview
        </h5>
        <div class="d-flex gap-2">
          <button
            *ngIf="selectedTemplate"
            type="button"
            class="btn btn-primary"
            (click)="useTemplate(selectedTemplate!)">
            <i class="fas fa-check me-2"></i>
            {{
              isCurrentTemplate(selectedTemplate.id)
                ? 'Use Again'
                : 'Use This Template'
            }}
          </button>
          <button
            type="button"
            class="btn-close"
            aria-label="Close"
            (click)="closePreview()"></button>
        </div>
      </div>
      <div class="modal-body" *ngIf="selectedTemplate">
        <div class="template-preview-content">
          <div class="row">
            <div class="col-md-8">
              <h6>{{ selectedTemplate.name }}</h6>
              <p class="text-muted" *ngIf="selectedTemplate.description">
                {{ selectedTemplate.description }}
              </p>

              <!-- Template Details -->
              <div class="template-details">
                <div class="row">
                  <div class="col-md-6">
                    <div class="detail-item">
                      <strong>Category:</strong>
                      <span class="ms-2">
                        {{
                          categoryMap[selectedTemplate.categoryId] ||
                            'Uncategorized'
                        }}
                      </span>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="detail-item">
                      <strong>Usage Count:</strong>
                      <span class="ms-2">
                        {{ selectedTemplate.usageCount || 0 }} times
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Preview Placeholder -->
              <div class="preview-placeholder mt-4">
                <div class="alert alert-info" role="alert">
                  <div class="d-flex align-items-center">
                    <i class="fas fa-info-circle me-3"></i>
                    <div>
                      <strong>Template Configuration Preview</strong>
                      <p class="mb-0">
                        This template contains pre-configured form fields,
                        pricing rules, and workflow settings that will be
                        applied to your new service.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-md-4">
              <div class="template-actions">
                <div class="action-card">
                  <h6>Ready to use this template?</h6>
                  <p class="text-muted small">
                    This will create a new service using this template. You can
                    modify the settings and details from this template.
                  </p>
                  <button
                    type="button"
                    class="btn btn-success w-100"
                    (click)="useTemplate(selectedTemplate!)">
                    <i class="fas fa-arrow-right me-2"></i>
                    {{
                      isCurrentTemplate(selectedTemplate.id)
                        ? 'Use Again'
                        : 'Proceed'
                    }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-secondary"
          (click)="closePreview()">
          Cancel
        </button>
        <button
          *ngIf="selectedTemplate"
          type="button"
          class="btn btn-primary"
          (click)="useTemplate(selectedTemplate!)">
          <i class="fas fa-check me-2"></i>
          {{
            isCurrentTemplate(selectedTemplate.id)
              ? 'Use Again'
              : 'Use This Template'
          }}
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Modal backdrop -->
<div *ngIf="showPreviewModal" class="modal-backdrop fade show"></div>

<!-- Use Template Confirmation Modal -->
<irembogov-use-template-confirmation-modal
  [show]="showUseTemplateModal"
  [templateName]="templateToUse?.name || ''"
  (confirmed)="confirmUseTemplate()"
  (cancelled)="cancelUseTemplate()">
</irembogov-use-template-confirmation-modal>
